<template>
  <div class="p-the-page-l04 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <CMS
        contents_type="block_contents"
        location_code="IC_TOP_01_005_news"
      />

      <div class="c-common-inner" :style="addMarginTop">
        <CmsHeaderSearch :currentId="tabId" :switchTab="switchTab" />
        <Z03Banner :tab_id="tabId" />
        <Z04RecommendMenu :tab_id="tabId" />
        <Z05Ranking :tab_id="tabId" />
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import Z03Banner from "@/general/components/pages/parts/ProductTop/Z03Banner.vue";
import Z04RecommendMenu from "@/general/components/pages/parts/ProductTop/Z04RecommendMenu.vue";
import Z05Ranking from "@/general/components/pages/parts/ProductTop/Z05Ranking.vue";
import Z06OfficialSNSAccount from "@/general/components/pages/parts/ProductTop/Z06OfficialSNSAccount.vue";
import Z07WhatsNew from "@/general/components/pages/parts/ProductTop/Z07WhatsNew.vue";
import AuthStorage from "@/general/utils/auth";
import CMS from "@/general/components/CMS.vue";
import commons from "@/common/store/modules/commons";

export default {
  name: "ProductTop",
  components: {
    Z03Banner,
    Z04RecommendMenu,
    Z05Ranking,
    Z06OfficialSNSAccount,
    Z07WhatsNew,
    CMS
  },
  props: {
    boCode: {
      type: String
    }
  },
  data() {
    return {
      tabId: 1
    };
  },
  computed: {
    /** @returns {boolean} */
    isSp() {
      return this.$store.state.globals.isLargeBreakpointWidthOfSp;
    },

    headerHeight() {
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
    },

    /** @returns {object} */
    addMarginTop() {
      const style = {
        marginTop: this.headerHeight.toString() + "px"
      };
      return this.isSp ? style : {};
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedParam = urlParams.get("selected");

    if (urlParams.has("selected")) {
      if (selectedParam == "life") {
        this.switchTab(0);
      } else if (selectedParam == "goods") {
        this.switchTab(1);
      }
    } else {
      window.history.replaceState(null, "", "?selected=goods");
      this.switchTab(1);
    }
  },
  methods: {
    switchTab(id) {
      this.tabId = id;
    },
    mounted() {
      AuthStorage.checkLogin();
    }
  }
};
</script>

<style lang="scss" scoped>
.p-the-page-l04 {
  &__inner {
    max-width: rem(1110);
    padding: rem(32) 0 rem(56);
    margin: 0 auto;

    @include sp {
      padding: rem(16) 0 rem(48);
    }
  }

  &__content {
    margin-top: rem(24);

    @include sp {
      margin-top: rem(8);
    }
  }
}
</style>
